import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { NbLoginComponent, NbAuthSocialLink, getDeepFromObject, NbAuthResult, NbAuthService } from '@nebular/auth';
import { Router } from '@angular/router';
import { LenguageService } from '../../../@core/utils/lenguage.service'


@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends NbLoginComponent {

  redirectDelay: number = 0;
  showMessages: any = {};
  strategy: string = 'email';

  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  submitted: boolean = false;
  socialLinks: NbAuthSocialLink[] = [];
  rememberMe = false;

  constructor(
    private auth: AuthService,
    NbAuth: NbAuthService,
    cd: ChangeDetectorRef,
    public language: LenguageService,
    router: Router) {
    super(NbAuth, {}, cd, router);
  }

  login(): void {
    this.errors = [];
    this.messages = [];
    this.submitted = true;

    this.auth.login(this.user)
      .then(result => {
        this.submitted = false;
        this.showMessages = { success: true }
        localStorage.setItem("User", JSON.stringify(result));
        this.auth.getToken()
          .then((token) => {
            this.messages = [this.language.getLabel("login_access")];
            this.router.navigateByUrl('home');

            this.cd.detectChanges();
          });
      })
      .catch((error) => {
        this.submitted = false;
        this.showMessages = { error: true }
        this.errors = [this.language.getLabel("login_error")]

        this.cd.detectChanges();
      });

  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }

}
